import onGetTriageCounters from './onGetTriageCounters';
import onGetTriageRequests from './onGetTriageRequests';
import onGetMoreTriageRequests from './onGetMoreTriageRequests';
import onGetTriageRequestByNoteId from './onGetTriageRequestByNoteId';
import onUpdateTriageRequestByNoteId from './onUpdateTriageRequestByNoteId';
import onUpdatedBloodPressureReading from './onUpdatedBloodPressureReading';

export default {
  onGetTriageCounters,
  onGetTriageRequests,
  onGetMoreTriageRequests,
  onGetTriageRequestByNoteId,
  onUpdateTriageRequestByNoteId,
  onUpdatedBloodPressureReading,
};
